// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldstakeEntity from './entities/ldstake.json';
import ldstakeMenu from '../pages/ldstake/menu.json';
import ldstakeFullForm from '../pages/ldstake/forms/full.json';
import ldstakeContextForm from '../pages/ldstake/forms/context.json';
import ldstakeMiniForm from '../pages/ldstake/forms/mini.json';
import ldstakeLookupForm from '../pages/ldstake/forms/lookup.json';
import ldstakeTableView from '../pages/ldstake/views/table.json';
import ldstakeStagesView from '../pages/ldstake/views/stages.json';
import ldstakeCardsView from '../pages/ldstake/views/cards.json';
import ldstakeInlineView from '../pages/ldstake/views/inline.json';
import ldstakeBacklogView from '../pages/ldstake/views/backlog.json';
import ldstakeSplitView from '../pages/ldstake/views/split.json';
import ldstakeCalendarView from '../pages/ldstake/views/calendar.json';
import ldstakeDashboardView from '../pages/ldstake/views/dashboard.json';

/** Тип запису «Інтерес зацікавленої сторони» зі сторінками пакета: меню, форми та подання з pages/ldstake/. */
export const ldstakeDefinition: IRecordTypeDefinition = {
  ...ldstakeEntity,
  views: assembleViewSet({
      table: ldstakeTableView,
      stages: ldstakeStagesView,
      cards: ldstakeCardsView,
      inline: ldstakeInlineView,
      backlog: ldstakeBacklogView,
      split: ldstakeSplitView,
      calendar: ldstakeCalendarView,
      dashboard: ldstakeDashboardView,
  }),
  form: ldstakeFullForm,
  forms: { full: ldstakeFullForm, context: ldstakeContextForm, mini: ldstakeMiniForm, lookup: ldstakeLookupForm },
  menu: ldstakeMenu,
} as IRecordTypeDefinition;
